import { render, staticRenderFns } from "./BookCarouselItem.vue?vue&type=template&id=2e108bbf&"
import script from "./BookCarouselItem.vue?vue&type=script&lang=js&"
export * from "./BookCarouselItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports